export const pushToDataLayer = (eventData: object) => {
    if (typeof window.dataLayer !== 'object') {
        return;
    }

    window.dataLayer.push(eventData);
}
